module.exports = __webpack_public_path__ + "img/t5-1.ed2f018e.jpg";